// 产品信息
import productApi from '../../../api/products/products'
import * as types from '../../types/type'
// import config from './../../config'

export default {
  state: {
    productTypes: [],
    productList: []
  },
  getters: {
    [types.GET_PRODUCT_TYPE_LIST]: state => state.productTypes,
    [types.GET_PRODUCT_LIST]: state => state.productList
  },
  actions: {
    [types.GET_PRODUCTS_INFO]: ({commit}, params) => productApi.getProductList(params)
  },
  mutations: {
    [types.SET_PRODUCT_TYPE_LIST] (state, data) {
      state.productTypes = data
    },
    [types.SET_PRODUCT_LIST] (state, data) {
      if (data.isConcat) {
        state.productList = state.productList.concat(data.productList)
      } else {
        state.productList = data.productList
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/products/products.js